import "./CookieBanner.css";
import React, { useState, useEffect } from "react";

function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <p>
        We use essential cookies to make our site work. With your consent, we
        may also use non-essential cookies to improve user experience and
        analyze website traffic. By clicking "Accept," you agree to our
        website's cookie use as described in our{" "}
        <a href="/cookie-policy">Cookie Policy</a>.
      </p>

      <button class="btn-cookie" onClick={acceptCookies}>
        Accept
      </button>
      <button class="btn-cookie" onClick={rejectCookies}>
        Reject
      </button>
    </div>
  );
}

export default CookieBanner;
